import { NgModule } from '@angular/core';

import BetslipTypesStateStorageService from './services/betslip-types-state-storage.service';

@NgModule({
    providers: [BetslipTypesStateStorageService],
})
export default class BetslipTypesModule {}
